"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessAddress = exports.Address = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const city_state_zip_1 = require("../../utils/city-state-zip");
const base_react_components_1 = require("@navinc/base-react-components");
exports.Address = (0, styled_components_1.default)(base_react_components_1.Copy).withConfig({ displayName: "reports-Address", componentId: "reports-78ke00" }) `
  font-style: normal;
  margin-bottom: 8px;
  line-height: 18px;
`;
/**
 * Formatted address wrapped in a paragraph element
 */
const BusinessAddress = (_a) => {
    var { address = '', street = [], street1, city = '', name = '', state = '', zip = '', zipcode = zip } = _a, rest = __rest(_a, ["address", "street", "street1", "city", "name", "state", "zip", "zipcode"]);
    return (react_1.default.createElement(exports.Address, Object.assign({ size: "sm" }, rest),
        name ? (react_1.default.createElement(react_1.default.Fragment, null,
            name,
            " ",
            react_1.default.createElement("br", null))) : (''),
        (street === null || street === void 0 ? void 0 : street[0]) ? (react_1.default.createElement(react_1.default.Fragment, null,
            street[0],
            react_1.default.createElement("br", null),
            (0, city_state_zip_1.cityStateZip)({ city, state, zipcode }))) : street1 ? (react_1.default.createElement(react_1.default.Fragment, null,
            street1,
            react_1.default.createElement("br", null),
            (0, city_state_zip_1.cityStateZip)({ city, state, zipcode }))) : (address)));
};
exports.BusinessAddress = BusinessAddress;
exports.default = (0, styled_components_1.default)(exports.BusinessAddress).withConfig({ componentId: "reports-98b5nl" }) ``;
//# sourceMappingURL=index.js.map